import { Skeleton } from '@mui/material';
import React from 'react';

const BlacklistRowSkeleton = () => {
  return (
    <tr>
      <td>
        <Skeleton variant="rounded" width={20} height={20} sx={{ margin: '5px 10px 5px 12px' }} />
      </td>
      <td>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Skeleton variant="circular" width={30} height={30} />
          <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
        </div>
      </td>
      <td>
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
      </td>
      <td>
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
      </td>
      <td>
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
      </td>
      <td>
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
      </td>
      <td>
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '60%' }} />
      </td>
      <td>
        <Skeleton variant="rounded" width={20} height={20} />
      </td>
    </tr>
  );
};

export default BlacklistRowSkeleton;
